import React, { useState } from "react";
import { ListGroup, Image, Collapse } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { CiSettings } from "react-icons/ci";
import { FiMonitor, FiChevronDown, FiChevronRight } from "react-icons/fi";
import Logout from "../assets/logout.svg";
import Logo from "../assets/logo.svg";
import { useAuth } from "../context/AuthProvider";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { logout } = useAuth();
  const [monitorsOpen, setMonitorsOpen] = useState(true);

  const navItems = [
    {
      path: "/",
      icon: <CiSettings className="fs-20" />,
      label: "General Settings",
      match: (path) => path === "/",
    },
    {
      label: "Monitor Settings",
      icon: <FiMonitor className="fs-20" />,
      hasChildren: true,
      children: [
        {
          path: "/monitors",
          icon: <FiMonitor className="fs-18" />,
          label: "Sneaker & Alternative",
          match: (path) => path.startsWith("/monitor"),
        },
      ],
    },
    {
      path: "/forwarding/add-forwards",
      icon: <CiSettings className="fs-20" />,
      label: "Forwarding Options",
      match: (path) => path === "/forwarding/add-forwards",
    },
  ];

  const comingSoonItems = [{ label: "Coming soon", disabled: true }];

  return (
    <div className={`sidebar d-flex flex-column justify-content-between ${isOpen ? "open" : ""}`}>
      <div className="d-flex flex-column">
        <div className="logo-container">
          <Image src={Logo} className="logo object-fit-cover" alt="logo" />
        </div>
        <div className="p-3">
          <ListGroup className="nav pt-1 ps-0" as="ul">
            {navItems.map((item, index) => {
              if (item.hasChildren) {
                return (
                  <React.Fragment key={`parent-${index}`}>
                    <ListGroup.Item
                      className="border-0 rounded-3 bg-transparent text-gray-2 fw-500"
                      as="li"
                    >
                      <div
                        className="d-flex align-items-center justify-content-between gap-2 fs-14 text-gray-2 fw-500"
                        onClick={() => setMonitorsOpen(!monitorsOpen)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          {item.icon} {item.label}
                        </div>
                        {monitorsOpen ? (
                          <FiChevronDown className="fs-16" />
                        ) : (
                          <FiChevronRight className="fs-16" />
                        )}
                      </div>
                    </ListGroup.Item>

                    <Collapse in={monitorsOpen}>
                      <div>
                        {item.children.map((child) => {
                          const isChildActive = child.match(location.pathname);
                          return (
                            <ListGroup.Item
                              key={child.path}
                              className={`border-0 rounded-3 ms-4 ${
                                isChildActive
                                  ? "bg-white-12 text-gray fw-600"
                                  : "bg-transparent text-gray-2 fw-500"
                              }`}
                              as="li"
                            >
                              <Link
                                to={child.path}
                                onClick={onClose}
                                className={`text-nowrap d-flex align-items-center gap-2 fs-13 text-decoration-none ${
                                  isChildActive
                                    ? "text-gray fw-600"
                                    : "text-gray-2 fw-500"
                                }`}
                              >
                                {child.icon} {child.label}
                              </Link>
                            </ListGroup.Item>
                          );
                        })}
                      </div>
                    </Collapse>
                  </React.Fragment>
                );
              }

              const isActive = item.match(location.pathname);
              return (
                <ListGroup.Item
                  key={item.path}
                  className={`border-0 rounded-3 ${
                    isActive
                      ? "bg-white-12 text-gray fw-600"
                      : "bg-transparent text-gray-2 fw-500"
                  }`}
                  as="li"
                >
                  <Link
                    to={item.path}
                    onClick={onClose}
                    className={`d-flex align-items-center gap-2 fs-14 text-decoration-none ${
                      isActive ? "text-gray fw-600" : "text-gray-2 fw-500"
                    }`}
                  >
                    {item.icon} {item.label}
                  </Link>
                </ListGroup.Item>
              );
            })}

            {/* Coming Soon Items */}
            {comingSoonItems.map((item, index) => (
              <ListGroup.Item
                key={`coming-soon-${index}`}
                className="border-0 rounded-3 bg-transparent"
                as="li"
                style={{ opacity: 0.4, cursor: "not-allowed" }}
              >
                <div className="d-flex align-items-center gap-2 fs-14 text-gray-2 fw-500">
                  <CiSettings className="fs-20" /> {item.label}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </div>

      <div className="module-logout position-relative mx-3 mb-3">
        <button
          onClick={(e) => {
            e.preventDefault();
            logout();
          }}
          className="btn btn-secondary w-100 rounded-3 py-2 px-3 fw-600 fs-14 d-flex align-items-center justify-content-center gap-2"
        >
          <Image src={Logout} className="object-fit-cover" alt="logout" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
